import { Tooltip as TooltipPrimitive } from "#lib/internal/components"
import TooltipContent from "./TooltipContent.svelte"
import TooltipRoot from "./TooltipRoot.svelte"
import TooltipTrigger from "./TooltipTrigger.svelte"

export type { TooltipContentProps } from "./TooltipContent.svelte"

export const Tooltip = {
  Provider: TooltipPrimitive.Provider,
  Arrow: TooltipPrimitive.Arrow,
  Root: TooltipRoot,
  Trigger: TooltipTrigger,
  Content: TooltipContent,
} as const
